module.exports = __webpack_public_path__ + "static/img/12.1.f62bc97.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/6/eng/12.1.png
// module id = qw0Q
// module chunks = 0